// extracted by mini-css-extract-plugin
export default {"ctn":"account-analytics_ctn__MrOOb","value":"account-analytics_value__Zb8RK","label":"account-analytics_label__cGzT6"};